
import './index.scss';

const Coin = (prop: {
    count: number,
    size?: number
}) => {
    return <span className='coin-number'>
        <img style={{
            height: (prop.size || 28) * 1.214 / 2
        }} src="https://img.ithome.com/m/images/app/coin-ico.png" />
        <span style={{
            fontSize: (prop.size || 28) / 2
        }}>{processNUmber(prop.count)}</span>
    </span>
}

export function processNUmber(str: any) {
    try {
        var target = '',
            arrStore = [];
        target = typeof str === 'number' ? str.toString() : str;
        var targetArray = target.split('').reverse();
        for (var i = 0; i < targetArray.length; i++) {
            arrStore.unshift(targetArray[i])
            if ((i + 1) % 3 === 0) {
                if ((i + 1) !== targetArray.length) {
                    arrStore.unshift(',');
                }
            }
        }
        return arrStore.join('');
    } catch (e) { }

    return str;
}

export default Coin;